import PropTypes from 'prop-types';
import React from 'react';

const defaultPropTypes = {
  children: PropTypes.node,
};

const TopBar = function TopBar(props) {
  return (
    <div id="top_bar">
      <div className="md-top-bar">
        <div className="uk-container-center">
          <div className="uk-clearfix">
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

TopBar.ActionsLeft = function ActionsLeft(props) {
  return (
    <div className="md-top-bar-actions-left">
      {props.children}
    </div>
  );
};

TopBar.ActionsRight = function ActionsRight(props) {
  return (
    <div className="md-top-bar-actions-right">
      {props.children}
    </div>
  );
};

TopBar.propTypes = defaultPropTypes;
TopBar.ActionsLeft.propTypes = defaultPropTypes;
TopBar.ActionsRight.propTypes = defaultPropTypes;

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar.js